module.exports = __webpack_public_path__ + "media/img/event/ohana-banner-e4169c20cd79e36d8ff4cc529971f662.jpg";